export default __webpack_public_path__ + "static/media/avatar2.d81c150c.png";